import { AuthenticatedUser } from '@shared/Authentication/shared/domain';
import { gql } from 'graphql-tag';

export const GET_USER_INFORMATION = gql`
  query UserInformation($userId: Float!) {
    userInformation(userId: $userId) {
      id
      firstName
      lastName
      email
      phoneNumber
      status
      role
      identityDocumentType
      identityDocumentCode
    }
  }
`;

export type UserInformationRequest = {
  userId: number;
};

export type UserInformationResponse = {
  userInformation: AuthenticatedUser;
};
